export const RULES = Object.freeze({
  maxTurns: 6,
  laneCount: 3,
  maxDepth: 3,
  initialHappiness: 10,
  idealHappiness: 15,
  oversleepLine: 16,
  nightmareLine: 0,
  initialHand: 5,
  drawPerTurn: 1,
  openSupplyInitialEnergy: 3,
  openSupplyRecovery: 3,
  openSupplyMaxEnergy: 6,
});
